"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 2H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM5 11V5l6 3-6 3z"];
//# sourceMappingURL=video.js.map